// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"d1ce6852","757":"e7326a0a","775":"e52e3320"}[chunkId] + ".chunk.css";
};